// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".interna_left-leave-to,.interna_right-enter{transform:translate3d(100vw,0,0)!important}.interna_left-enter-to,.interna_left-leave,.interna_right-enter-to,.interna_right-leave{transform:none}.interna_left-enter,.interna_right-leave-to{transform:translate3d(-100vw,0,0)!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
